export default {
  text: 'Voltar',
};
